import BaseController from "controllers/backend/base"

import ResultsFilterWidget from "widgets/backend/resultsFilterWidget"

class Controller extends BaseController {
  call() {
    super.call()
    bindResultsFilter.call(this)
    submitTender.call(this)
  }
};

var bindResultsFilter = function() {
  let elem = this.root
  this.resultsFilter = new ResultsFilterWidget(elem)
}

var submitTender = function() {
  this.root.on("click", ".publish-tender", (e) => {
    const id = e.target.id
    publishTender(id)
  })
}

var publishTender = function(tenderId) {
  $.ajax({
    url: '/backend/tenders/publish_tender.json',
      dataType: 'json',
      method: 'POST',
      data: {
        id: tenderId,
      },
      success: function (r) {
        if ('danger' in r.flash) {
          return false
        } else {
          window.location.href = '/backend/tenders'
          console.log('Succeed');
        }
      },
      error: (xhr, text, error) => {
        console.log('Failed');
        swal({
          type: 'error',
          title: xhr.responseJSON.error
        })
      }
  });
}

export default Controller;